import { AdsGrid } from './ads-grid';
import { getConfig } from './grid-config';
import { getAdsPlugins } from './plugins';

export function createAdsGrid({
  dataSource,
  filterService,
  getAdditionalPlugins,
  preferenceConfig,
  router,
  scope,
  addDateChangeListener,
  p$daterange,
  isForVNext = false,
  viewport,
  adsTabPerfMarker,
  customHeaderOffset,
  newI18n,
  currentEntity,
  CampaignAdgroupSelectorEdmView,
  PredicateListReact,
  pageName,
  preexecuteFlag = false,
  deps = null,
  campaignContext,
  shouldSendOpportunityLog,
  logOpportunity,
  isDataFetchManagerSource,
  serverContext,
  loadClipchampPlayer,
}) {
  return new AdsGrid({
    isForVNext,
    newI18n,
    campaignContext,
    filterService,
    deps,
    serverContext,
    shouldSendOpportunityLog,
    logOpportunity,
    adsTabPerfMarker,
    loadClipchampPlayer,
    getGridConfig: view => getConfig({
      dataSource,
      scope,
      view,
      serverContext,
      filterService,
      preferenceConfig,
      router,
      isForVNext,
      newI18n,
      deps,
      viewport,
      customHeaderOffset,
      shouldSendOpportunityLog,
      logOpportunity,
      adsTabPerfMarker,
      isDataFetchManagerSource,
      loadClipchampPlayer,
    }),
    getPlugins: view => getAdsPlugins({
      view,
      filterService,
      scope,
      addDateChangeListener,
      p$daterange,
      isForVNext,
      deps,
      router,
      adsTabPerfMarker,
      newI18n,
      currentEntity,
      CampaignAdgroupSelectorEdmView,
      PredicateListReact,
      preexecuteFlag,
      serverContext,
    }).concat(getAdditionalPlugins(view)),
    router,
    scope,
    preferenceConfig,
    pageName,
    preexecuteFlag,
  });
}
